import axios from 'axios';
import { getJwt, removeJwt } from './jwt';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use(async (config) => {
  const { headers } = config;

  const jwt = getJwt();
  if (jwt) {
    // @ts-ignore
    headers.Authorization = `Bearer ${jwt}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => Promise.resolve(response),
  async (error) => {
    if (error.config && error.response) {
      if (error.response.status === 401 && error.config.url !== '/login') {
        removeJwt();
        window.location.reload();
      } else if (error.response.status >= 500) {
        // TODO: Exibir erros de forma amigável
        // eslint-disable-next-line no-alert
        alert(
          'Houve um problema ao realizar a sua requisição e já estamos resolvendo. Por favor, tente novamente mais tarde.'
        );
      } else if (error.response.status === 0) {
        // TODO: Exibir erros de forma amigável
        // eslint-disable-next-line no-alert
        alert(
          'Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente'
        );
      }
    }

    return Promise.reject(error);
  }
);

export default {
  get: api.get.bind(api),
  post: api.post.bind(api),
  postForm: api.postForm.bind(api),
  put: api.put.bind(api),
  patch: api.patch.bind(api),
  delete: api.delete.bind(api),
};
